import { render, staticRenderFns } from "./touZiList.vue?vue&type=template&id=a6cc7ef4&"
import script from "./touZiList.vue?vue&type=script&lang=js&"
export * from "./touZiList.vue?vue&type=script&lang=js&"
import style0 from "./touZiList.vue?vue&type=style&index=0&id=a6cc7ef4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports